import { ChartElementHandler } from './chart.element-handler';

export class ColumnChartElementHandler extends ChartElementHandler<'chartColumn'> {
  readonly type = 'chartColumn';
  readonly flipXY = false;
}
